import { drybulkCargoOperationsService } from "@services/drybulkCargoOperationsApi";
import { useQuery } from "@tanstack/react-query";
import { DETAIL_REFETCH_INTERVAL_MS, DRYBULK_CARGO_OPS_QUERY_KEYS } from "../constants";

/**
 * DBCO-0029 - the operation with its sequences and the Shipper / S.Pile grids (one request serves the
 * header and the grids). Refreshes every 30 s (AC12, N-10) but never while a side panel or dialog is
 * open, so an edit in progress is not disturbed.
 */
export const useCargoOperationDetail = (
  operationId: string | undefined,
  { paused = false }: { paused?: boolean } = {},
) =>
  useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.detail(operationId ?? ""),
    queryFn: () => drybulkCargoOperationsService.getDetail(operationId!),
    enabled: Boolean(operationId),
    // Every visit reads fresh (the global stale time would serve a recent cache), so the operation page can
    // snapshot the Draft it is opened on (DBCO-0065 D18).
    refetchOnMount: "always",
    refetchInterval: paused ? false : DETAIL_REFETCH_INTERVAL_MS,
    refetchOnWindowFocus: false,
    retry: false,
  });

/**
 * DBCO-0029 - a passive view of the cached detail: it never fetches and never polls, so a host page can
 * show the figures every sequence change writes into the cache without owning a second refresh schedule.
 */
export const useCachedCargoOperationDetail = (operationId: string | undefined) =>
  useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.detail(operationId ?? ""),
    queryFn: () => drybulkCargoOperationsService.getDetail(operationId!),
    enabled: false,
  });
